export const conect= {
  apiKey: "AIzaSyDvC2zEZ187wuPewv4-AP_nbtL3yXMv8LU",
  authDomain: "lab-notes-89994.firebaseapp.com",
  projectId: "lab-notes-89994",
  storageBucket: "lab-notes-89994.appspot.com",
  messagingSenderId: "982977160490",
  appId: "1:982977160490:web:e9a60909296534a418aa53"
};